import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/components/document-title";
import { EmailVerifyPage } from "@/features/onboarding/pages/email-verify-page";

export const Route = createFileRoute("/onboarding/email-verify")({
	head: () => pageTitle("Verify your email address"),
	component: EmailVerifyPage,
});
